import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface VisitorState {
  visitorId: string | null;
  visitorDate: string | null; // YYYY-MM-DD for daily reset
}

const initialState: VisitorState = {
  visitorId: null,
  visitorDate: null,
};

function generateVisitorId(): string {
  // URL-safe, 32 chars
  const array = new Uint8Array(24);
  if (typeof window !== 'undefined' && window.crypto?.getRandomValues) {
    window.crypto.getRandomValues(array);
  } else {
    for (let i = 0; i < array.length; i += 1) {
      array[i] = Math.floor(Math.random() * 256);
    }
  }
  return btoa(String.fromCharCode(...Array.from(array)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

function todayString(): string {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

const slice = createSlice({
  name: 'visitor',
  initialState,
  reducers: {
    initVisitorId(state) {
      if (typeof window === 'undefined') return;
      const today = todayString();
      const storedDate = localStorage.getItem('visitorDate');
      let id = localStorage.getItem('visitorId');
      const valid = id && /^[A-Za-z0-9_-]{16,128}$/.test(id);
      if (!storedDate || storedDate !== today || !valid) {
        // New day or invalid id → generate fresh visitor id
        id = generateVisitorId();
        localStorage.setItem('visitorId', id);
        localStorage.setItem('visitorDate', today);
      }
      state.visitorId = id || null;
      state.visitorDate = today;
    },
    setVisitorId(state, action: PayloadAction<string>) {
      const id = action.payload;
      if (typeof window !== 'undefined') {
        localStorage.setItem('visitorId', id);
      }
      state.visitorId = id;
    },
  },
});

export const { initVisitorId, setVisitorId } = slice.actions;
export default slice.reducer;
